import { Link } from "react-router-dom";
import { getProduct } from "../../data";
import { PrimaryButton } from "./Buttons";
import StatusBadge from "./StatusBadge";

export function ProductCard({ product, schedulePath }) {
  const detail =
    product.type === "protein_shake"
      ? `/protein-shakes/${product.id}`
      : `/fruits/${product.id}`;
  return (
    <article className="product-card h-100">
      <Link
        to={detail}
        className={`${product.type === "protein_shake" ? "product-image" : "basket-product-image"}`}
      >
        <img src={product.image} alt={product.name} loading="lazy" />
        <span className="price-pill">₹{product.price}</span>
      </Link>
      <div className="p-3 p-lg-4 d-flex flex-column flex-grow-1">
        <p className="card-kicker mb-1">
          {product.type === "protein_shake"
            ? "Natural shake"
            : "Seasonal basket"}
        </p>
        <h3>{product.name}</h3>
        <p className="text-secondary small flex-grow-1">
          {product.description}
        </p>
        {product.protein && (
          <div className="nutrition-row">
            <span>
              <i className="fa-solid fa-seedling" /> {product.protein} protein*
            </span>
            <span>{product.calories}*</span>
          </div>
        )}
        {product.weight && (
          <div className="nutrition-row">
            <span>
              <i className="fa-solid fa-weight-scale" /> {product.weight}
            </span>
          </div>
        )}
        <div className="d-flex gap-2 mt-3">
          <Link to={detail} className="btn btn-soft flex-fill">
            Details
          </Link>
          <PrimaryButton
            to={schedulePath || `/schedule/${product.type}/${product.id}`}
            className="flex-fill"
          >
            Schedule
          </PrimaryButton>
        </div>
      </div>
    </article>
  );
}

export function DeliveryCard({ delivery }) {
  const product = getProduct(delivery.productId);
  return (
    <article className="delivery-card">
      <img src={product?.image} alt="" />
      <div className="flex-grow-1 min-w-0">
        <div className="d-flex justify-content-between gap-2">
          <div>
            <span className="card-kicker">{delivery.date}</span>
            <h3 className="mb-1">{product?.name}</h3>
          </div>
          <div className="mt-1">
            <StatusBadge status={delivery.status} />
          </div>
        </div>
        <p className="small text-secondary mb-3">
          <i className="fa-regular fa-clock me-2" />
          {delivery.timeSlot}
          <span className="mx-2">·</span>
          <i className="fa-solid fa-location-dot me-2" />
          {delivery.addressArea || "Saved address"}
        </p>
        <div className="d-flex justify-content-between align-items-center">
          <span className="small fw-semibold">
            {delivery.recurring
              ? `${delivery.frequency || "Recurring"}${delivery.days?.length ? ` · ${delivery.days.join(", ")}` : ""}`
              : "One time"}
          </span>
          <Link to={`/deliveries/${delivery.id}`} className="text-link">
            View details <i className="fa-solid fa-arrow-right" />
          </Link>
        </div>
      </div>
    </article>
  );
}

export function AddressCard({
  address,
  selected,
  onSelect,
  onEdit,
  onDelete,
  actions = true,
}) {
  return (
    <article
      className={`address-card ${selected ? "selected" : ""}`}
      onClick={() => onSelect?.(address.id)}
    >
      <div className="d-flex justify-content-between align-items-start">
        <span className="address-type">
          <i
            className={`fa-solid ${address.type === "Work" ? "fa-building" : "fa-house"}`}
          />{" "}
          {address.type}
        </span>
        {address.default && <span className="default-tag">Default</span>}
      </div>
      <h3>{address.name}</h3>
      <p>
        {address.line}
        <br />
        {address.area}, {address.city} – {address.pincode}
      </p>
      {actions && (
        <div className="d-flex gap-3">
          <button
            type="button"
            className="btn-link"
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.(address);
            }}
          >
            Edit
          </button>
          <button
            type="button"
            className="btn-link text-danger"
            onClick={(e) => {
              e.stopPropagation();
              onDelete?.(address.id);
            }}
          >
            Delete
          </button>
        </div>
      )}
    </article>
  );
}

export function EmptyState({
  icon = "fa-box-open",
  title,
  copy,
  action = "Explore services",
  to = "/protein-shakes",
}) {
  return (
    <div className="empty-state">
      <span>
        <i className={`fa-solid ${icon}`} />
      </span>
      <h2>{title}</h2>
      <p>{copy}</p>
      <PrimaryButton to={to}>{action}</PrimaryButton>
    </div>
  );
}
export function LoadingSkeleton({ count = 3 }) {
  return (
    <div className="row g-3">
      {Array.from({ length: count }).map((_, i) => (
        <div className="col-12 col-md-6" key={i}>
          <div className="skeleton-card">
            <div />
            <span />
            <span />
          </div>
        </div>
      ))}
    </div>
  );
}
